import { createZEMClient, type Environment } from '@zelostech/zem-sdk-web';

const isProduction = process.env.NODE_ENV === 'production';

const environment = process.env.ZELOS_FE_ENV as Environment;

// 从 meta 标签获取 build-number
const getBuildNumber = (): string => {
  const buildNumberMeta = document.getElementById('build-number');
  return buildNumberMeta?.getAttribute('data-content') || 'Unknown';
};

export const zemClient = createZEMClient({
  appKey: 'bugs',
  environment,
  enable: isProduction,
  version: getBuildNumber(),
  debug: environment !== 'prod',
  volcano: {
    projectId: '0479500c-d347-4eec-8aa4-ebced5b57568',
    topicId: 'f5ed0d74-14de-46a7-8ade-94495b0d54ce',
  },
});
